export const queryCacheDuration = 3600 * 24 * 500;
